import { MODAL_CLASSES } from './const.js';

/**
 * "Деактивирует" (убирает класс) переданные элементы по переданному классу
 * Если элементами являются input-ы, то убирает атрибут checked
 * @param {NodeList} items список элементов которые нужно "деактивировать" 
 * @param {string} className 
 */
const deactivateItems = (items, className = null) => {
  items.forEach((item) => {
    if (item.tagName === 'INPUT') {
      item.checked = false;
    } else {
      item.classList.remove(className);
    }
  });
};

/**
 * Получает координаты и/или размеры элемента
 * @param {HTMLElement} elem элемент, для которого нужно получить координаты и/или размеры
 * @returns {{top: number, left: number, right: number, bottom: number, width: number, height: number}} объект с координатами и размерами элемента
 */
const getCoords = (elem) => {
  const box = elem.getBoundingClientRect();

  return {
    top: box.top + window.scrollY,
    left: box.left + window.scrollX,
    right: box.right + window.scrollX,
    bottom: box.bottom + window.scrollY,
    width: box.width,
    height: box.height,
  };
};

/**
 * Удаляет HTML-теги из строки.
 *
 * @param {string} string - Входная строка, которая может содержать HTML-теги.
 * @returns {string} Входная строка с удалёнными HTML-тегами.
 * @example
 * stripHtmlTags("<p>Hello, <b>world!</b></p>") // Возвращает "Hello, world!"
 */
function stripHtmlTags(string) {
  return string.replace(/<[^>]*>/g, '');
}

/**
 * Показывает модальное окно
 * @param {HTMLElement} overlay - Элемент затемнения
 * @param {HTMLElement} container - Контейнер с формой
 * @param {HTMLElement} closeButton - Кнопка закрытия модального окна
 * @returns {void}
 */
function showModal(overlay, container, closeButton) {
  if (!overlay || !container) {
    console.error('Overlay or container not found');

    return;
  }

  overlay.classList.add(MODAL_CLASSES.OVERLAY.ACTIVE);
  container.classList.add(MODAL_CLASSES.FORM.ACTIVE);

  if (closeButton) {
    closeButton.classList.add(MODAL_CLASSES.OVERLAY.CLOSE_ACTIVE);
  }
}

/**
 * Скрывает модальное окно
 * @param {HTMLElement} overlay - Элемент затемнения
 * @param {HTMLElement} container - Контейнер с формой
 * @param {HTMLElement} closeButton - Кнопка закрытия модального окна
 * @returns {void}
 */
function hideModal(overlay, container, closeButton) {
  if (!overlay || !container) {
    console.error('Overlay or container not found');

    return;
  }

  overlay.classList.remove(MODAL_CLASSES.OVERLAY.ACTIVE);
  container.classList.remove(MODAL_CLASSES.FORM.ACTIVE);

  if (closeButton) {
    closeButton.classList.remove(MODAL_CLASSES.OVERLAY.CLOSE_ACTIVE);
  }
}

export { deactivateItems, getCoords, stripHtmlTags, showModal, hideModal };